import React, { useEffect } from 'react';
import { X } from 'lucide-react';

const Modal = ({
                   children,
                   title,
                   onClose,
                   size = 'md',
                   showCloseButton = true,
                   closeOnOverlayClick = true
               }) => {
    const sizeClasses = {
        sm: 'max-w-md',
        md: 'max-w-lg',
        lg: 'max-w-4xl',
        xl: 'max-w-6xl',
        full: 'max-w-full mx-4'
    };

    // Cerrar modal con tecla Escape
    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === 'Escape') {
                onClose();
            }
        };

        document.addEventListener('keydown', handleEscape);

        // Prevenir scroll del body cuando el modal está abierto
        document.body.style.overflow = 'hidden';

        return () => {
            document.removeEventListener('keydown', handleEscape);
            document.body.style.overflow = 'unset';
        };
    }, [onClose]);

    const handleOverlayClick = (e) => {
        if (closeOnOverlayClick && e.target === e.currentTarget) {
            onClose();
        }
    };

    return (
        <div className="fixed inset-0 z-[60] overflow-y-auto">
            <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">

                {/* Overlay/Backdrop */}
                <div
                    className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
                    onClick={handleOverlayClick}
                    aria-hidden="true"
                />

                {/* Centrado del modal */}
                <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
          &#8203;
        </span>

                {/* Contenedor del modal */}
                <div
                    className={`
            inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl 
            transform transition-all sm:my-8 sm:align-middle sm:w-full
            ${sizeClasses[size]}
            animate-fade-in
          `}
                    role="dialog"
                    aria-modal="true"
                    aria-labelledby="modal-title"
                >

                    {/* Header del modal */}
                    {(title || showCloseButton) && (
                        <div className="bg-white px-4 pt-5 pb-4 sm:p-6 border-b border-gray-200">
                            <div className="flex items-center justify-between">
                                {title && (
                                    <h3
                                        id="modal-title"
                                        className="text-lg leading-6 font-medium text-gray-900"
                                    >
                                        {title}
                                    </h3>
                                )}

                                {showCloseButton && (
                                    <button
                                        onClick={onClose}
                                        className="text-gray-400 hover:text-gray-600 transition-colors duration-200 p-1 rounded-md hover:bg-gray-100"
                                        aria-label="Cerrar modal"
                                    >
                                        <X className="h-6 w-6" />
                                    </button>
                                )}
                            </div>
                        </div>
                    )}

                    {/* Contenido del modal */}
                    <div className="bg-white px-4 pt-5 pb-4 sm:p-6">
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Modal;